export default __webpack_public_path__ + "static/media/deviant1.1549efd2.png";